import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReuseableBoxDetailsTableComponent } from "./reuseable-box-details-table/reuseable-box-details-table.component";
import { BoxDetailsTableModule } from "../add-details-for-box/add-details-for-box/child-component/box-details-table/box-details-table.module";
import { MatDialogModule } from "@angular/material/dialog";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { FuseSharedModule } from "@fuse/shared.module";

@NgModule({
  declarations: [ReuseableBoxDetailsTableComponent],
  imports: [
    CommonModule,
    BoxDetailsTableModule,
    MatDialogModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    FuseSharedModule
  ]
})
export class ReuseableBoxDetailsTableModule {}
